import { render, staticRenderFns } from "./CrossPublishingIndicator.vue?vue&type=template&id=de4c2696&scoped=true&"
import script from "./CrossPublishingIndicator.vue?vue&type=script&lang=js&"
export * from "./CrossPublishingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CrossPublishingIndicator.vue?vue&type=style&index=0&id=de4c2696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c2696",
  null
  
)

export default component.exports